'use client'

import { useState, useContext, useEffect } from 'react'

import { ConvertContext } from '@/app/providers'
import { BucketedVariation } from '@convertcom/js-sdk'

import BusinessDirectoryInner from '@/components/business-directory/BusinessDirectoryInner'
import ListArchiveItems from '@/components/list-archive/ListArchiveItems'
import BusinessDirectoryGrid from '@/components/business-directory/BusinessDirectoryGrid'

export default function BusinessDirectoryOuter() {
  const { sdkContext, isConvertReady } = useContext(ConvertContext)
  const [view, setView] = useState(null)

  useEffect(() => {
    if (!isConvertReady) {
      return
    }

    // If SDK isn't available (e.g. blocked by ad blocker), default to grid view
    if (!sdkContext) {
      setView('grid-view')
      return
    }

    const args = {
      locationProperties: {
        url: window.location.pathname,
        environment: process.env.NODE_ENV || 'production',
      },
    }

    const experience = sdkContext.runExperience(
      'business-directory-view',
      args,
    ) as BucketedVariation

    setView(experience?.key || 'grid-view')
  }, [isConvertReady, sdkContext, setView])

  if (view === null) {
    return null
  }

  const ResultsTemplate =
    view === 'grid-view'
      ? BusinessDirectoryGrid
      : () => (
          <div className="bg-theme py-l theme--primary-50">
            <div className="container">
              <ListArchiveItems />
            </div>
          </div>
        )

  return (
    <>
      <BusinessDirectoryInner
        algoliaIndex="wp_posts_all-businesses"
        ResultsTemplate={ResultsTemplate}
        filters={[
          {
            heading: 'Categories',
            attributes: [
              'taxonomies_hierarchical.all-business-categories.lvl0',
              'taxonomies_hierarchical.all-business-categories.lvl1',
            ],
            type: 'hierarchicalMenu',
          },
        ]}
      />
    </>
  )
}
